import { useEffect, useState } from 'react';
import TrackPlayer, { Capability } from 'react-native-track-player';
import { useSettingsStore } from '@annunciate/core';
const PLAYER_OPTIONS = {
    stoppingAppPausesPlayback: true,
    progressUpdateEventInterval: 3,
    capabilities: [
        Capability.Play,
        Capability.Pause,
        Capability.Stop,
        Capability.SkipToNext,
        Capability.SkipToPrevious,
        Capability.JumpForward,
        Capability.JumpBackward,
    ],
    compactCapabilities: [
        Capability.Play,
        Capability.Pause,
        Capability.JumpForward,
        Capability.JumpBackward,
    ],
};
export const useTrackPlayer = () => {
    const [isSetup, setIsSetup] = useState(false);
    const jumpForward = useSettingsStore(state => state.jumpForward);
    const jumpBackward = useSettingsStore(state => state.jumpBackward);
    useEffect(() => {
        async function run() {
            await TrackPlayer.setupPlayer({
                waitForBuffer: true,
                autoHandleInterruptions: true,
            });
            await TrackPlayer.updateOptions({
                ...PLAYER_OPTIONS,
                forwardJumpInterval: jumpForward || 15,
                backwardJumpInterval: jumpBackward || 15,
            });
            setIsSetup(true);
        }
        run();
    }, []);
    useEffect(() => {
        if (isSetup === true) {
            TrackPlayer.updateOptions({
                ...PLAYER_OPTIONS,
                forwardJumpInterval: jumpForward || 15,
                backwardJumpInterval: jumpBackward || 15,
            });
            const playbackSpeed = useSettingsStore.getState().playbackSpeed;
            TrackPlayer.setRate(playbackSpeed);
        }
    }, [isSetup, jumpForward, jumpBackward]);
};
//# sourceMappingURL=useTrackPlayer.js.map